import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-795f8a2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "r-menu-item"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M1.58517 0.292894C1.22254 -0.0976306 0.634601 -0.0976305 0.271972 0.292894C-0.0906577 0.683418 -0.0906577 1.31658 0.271972 1.70711L5.8434 7.70711C6.19494 8.08568 6.76098 8.09893 7.12746 7.73715L12.6989 2.23715C13.0769 1.86396 13.1025 1.23139 12.7559 0.824276C12.4094 0.417157 11.822 0.389654 11.444 0.762846L6.52792 5.61586L1.58517 0.292894Z",
  fill: "#30295C"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "r-sub-menu" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Drop = _resolveComponent("Drop")!

  return (_ctx.mode == 'vertical')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleclick())),
          class: "r-title"
        }, [
          _createTextVNode(_toDisplayString(_ctx.data.title || _ctx.data) + " ", 1),
          (_ctx.data.items)
            ? (_openBlock(), _createElementBlock("svg", {
                key: 0,
                class: _normalizeClass(_ctx.showsub ? 'revert' : ''),
                width: "13",
                height: "8",
                viewBox: "0 0 13 8",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, _hoisted_3, 2))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.items, (row) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "r-menu-title",
              onClick: ($event: any) => (_ctx.handleclick(row.key || row)),
              key: row.key || row
            }, _toDisplayString(row.title || row), 9, _hoisted_5))
          }), 128))
        ], 512), [
          [_vShow, _ctx.showsub]
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        (_ctx.data.items)
          ? (_openBlock(), _createBlock(_component_Drop, {
              key: 0,
              onCommand: _ctx.handleclick,
              class: _normalizeClass(_ctx.theme ? `r-menu-item r-menu-item-${_ctx.theme}` : 'r-menu-item'),
              title: _ctx.data.title,
              items: _ctx.data.items
            }, null, 8, ["onCommand", "class", "title", "items"]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleclick())),
              class: "r-menu-item"
            }, _toDisplayString(_ctx.data.title || _ctx.data), 1))
      ]))
}